import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';

class Filter extends React.Component {

    state = {
        local: this.props.local,
        filter: this.props.filter,
        desactivados: this.props.desactivados
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    }

    handleClose = (local, filter, desactivados) => (event) => {
        this.props.handleClose(local, filter, desactivados);
    }

    render() {

        const { local, filter, desactivados } = this.state;
        const { intl, info } = this.props;

        const nodes = info.security.locals
                        .filter((f) => f.leaf)
                        .sort((a, b) => a.name > b.name ? 1 : -1);

        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_18 align_center">
                        <TextField
                            fullWidth
                            id={'filter'}
                            name={'filter'}
                             label={intl.formatMessage({ id: 'form_field_name_filter' })}
                            className={'flex_full_row'}
                            value={filter}
                            onChange={this.handleChange}
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row margin_top_18 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="popup_all_users" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'desactivados'}
                                checked={desactivados}
                                onChange={this.handleChecked}
                                value="desactivados"
                                color="primary"
                            />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(local, filter, desactivados)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/manage/employees/FilterMenu.js